import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home'
import Profile from '@/components/profile'
import Workout from '@/components/workout'
/*import WorkoutAdd from '@/components/workoutAdd' */
import Search from '@/components/search'
import Login from '@/components/login'
import SignUp from '@/components/signup'
import Admin from '@/components/admin'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/login'
    },
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: true,
        showBack: false,
        showCalendar: true
      },
    },
    {
      path: '/workout/:id',
      name: 'workout',
      component: Workout,
      meta: {
        requiresAuth: true,
        showBack: true
      },
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/search',
      name: 'search',
      component: Search,
      meta: {
        requiresAuth: true,
        showBack: true
      },
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        showToolbar: false
      }
    },
    {
      path: '/signup',
      name: 'signup',
      component: SignUp,
      meta: {
        showToolbar: false
      }
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        showBack: true,
        showCalendar: false
      },
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js